import { useState, useEffect } from "react"

const usePurchaseRedirect = (onSuccess) => {
  const [purchaseSuccess, setPurchaseSuccess] = useState(false)

  useEffect(() => {
    const purchase = new URLSearchParams(window.location.search).get("purchase")
    const isSuccess = purchase === "success"
    if (isSuccess) {
      setPurchaseSuccess(true)
      onSuccess?.()
    }
    if (isSuccess || purchase === "cancelled") {
      window.history.replaceState({}, "", window.location.pathname)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const clearPurchaseSuccess = () => setPurchaseSuccess(false)

  return { purchaseSuccess, clearPurchaseSuccess }
}

export default usePurchaseRedirect
